export function isExpandableGridModel(model) {
  return (model === null || model === void 0 ? void 0 : model.hasExpandableRows) !== undefined;
}

/**
 * Expandable grid model. Allows for a grid with rows that can expand (e.g. A Tree Table)
 */
//# sourceMappingURL=ExpandableGridModel.js.map